import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { SvgIconModule } from '../svg-icon';
import { SimpleSelectModule } from '../simple-select/simple-select.module';
import { AutoCompleteModule } from '../auto-complete/auto-complete.module';
import { GeoSearchModule } from '../geo-search/geo-search.module';
import { TooltipInputModule } from '../tooltip-input/tooltip-input.module';

import { VenueCreatorComponent } from './venue-creator.component';

@NgModule({
    declarations: [VenueCreatorComponent],
    imports: [
        CommonModule,
        FormsModule,
        AutoCompleteModule,
        SimpleSelectModule,
        GeoSearchModule,
        TooltipInputModule,
        SvgIconModule
    ],
    exports: [
        VenueCreatorComponent,
    ]
})
export class VenueCreatorModule { }
